import { render, staticRenderFns } from "./DealerCard.vue?vue&type=template&id=41540055&scoped=true"
import script from "./DealerCard.vue?vue&type=script&lang=ts"
export * from "./DealerCard.vue?vue&type=script&lang=ts"
import style0 from "./DealerCard.vue?vue&type=style&index=0&id=41540055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41540055",
  null
  
)

export default component.exports